export const reviews = Object.freeze([
  {
    countryCode: 'US',
    categories: {
      '2': [
        {
          brand: 'Apple',
          model: 'iPhone',
          reviews: ['f6017532-2a40-4e86-8096-bec972daab14'],
        },
        {
          brand: 'Samsung',
          model: 'Galaxy',
          reviews: ['25fe9af1-2e85-4f03-bec4-cc27f0987752'],
        },
        {
          brand: 'Google',
          model: 'Pixel',
          reviews: ['61a43803-34e9-4366-b73c-3d36b92181ec'],
        },
      ],
      '528': [
        {
          brand: 'Apple',
          model: 'MacBook',
          reviews: ['bc17bd7d-c76b-40e9-bfa3-2c1d854cf18b'],
        },
      ],
      '5': [
        {
          brand: 'Apple',
          model: 'iPad',
          reviews: ['4942ea5d-5579-4782-a502-aecfa8edadd4'],
        },
      ],
    },
  },
  {
    countryCode: 'FR',
    categories: {
      '2': [
        {
          brand: 'Apple',
          model: 'iPhone',
          reviews: [
            // Preprod (testing)
            '762f9b61-55b7-4e14-a60a-1b07eebc487f',
            // Prod
            'bfc566df-6954-497b-81da-eed265c2254d',
          ],
        },
        {
          brand: 'Samsung',
          model: 'Galaxy',
          reviews: ['5d277a94-843f-47ae-bafa-b3a4a1a0854d'],
        },
        {
          brand: 'Google',
          model: 'Pixel',
          reviews: ['28672cb6-847a-4bd5-8f77-e83e0797f2eb'],
        },
      ],
      '528': [
        {
          brand: 'Apple',
          model: 'MacBook',
          reviews: ['a30a4abe-b49a-45e6-a388-dcf5f17f43be'],
        },
      ],
      '5': [
        {
          brand: 'Apple',
          model: 'iPad',
          reviews: ['25e18ce5-c4b8-4674-8936-011debdad5c4'],
        },
      ],
    },
  },
  {
    countryCode: 'UK',
    categories: {
      '2': [
        {
          brand: 'Apple',
          model: 'iPhone',
          reviews: [
            // Preprod (testing)
            'f65fa61d-0188-40ce-80d0-8657ee2c6bde',
            // Prod
            'b7aee9cc-7d54-4206-9a29-0ddd6bcb9dae',
          ],
        },
        {
          brand: 'Samsung',
          model: 'Galaxy',
          reviews: ['7bb064da-93f8-43a0-ac0b-6b8b5aa987f5'],
        },
        {
          brand: 'Google',
          model: 'Pixel',
          reviews: [],
        },
      ],
      '528': [
        {
          brand: 'Apple',
          model: 'MacBook',
          reviews: ['f7b3da95-9f04-4656-a529-f656cb1da05e'],
        },
      ],
      '5': [
        {
          brand: 'Apple',
          model: 'iPad',
          reviews: ['53314896-fb85-4553-a2f7-a4969a0b051d'],
        },
      ],
    },
  },
  {
    countryCode: 'ES',
    categories: {
      '2': [
        {
          brand: 'Apple',
          model: 'iPhone',
          reviews: ['389cb43a-35c6-4312-8d37-b5764dda6873'],
        },
        {
          brand: 'Samsung',
          model: 'Galaxy',
          reviews: ['2fd2a05a-d4b1-4782-a0e7-87dbc66276bd'],
        },
        {
          brand: 'Google',
          model: 'Pixel',
          reviews: ['cc02258d-7cb3-4163-9457-fe1332e5934d'],
        },
      ],
      '528': [
        {
          brand: 'Apple',
          model: 'MacBook',
          reviews: [],
        },
      ],
      '5': [
        {
          brand: 'Apple',
          model: 'iPad',
          reviews: ['a4873a9c-ec1b-4fa6-a180-1b4a0cc98d44'],
        },
      ],
    },
  },
  {
    countryCode: 'DE',
    categories: {
      '2': [
        {
          brand: 'Apple',
          model: 'iPhone',
          reviews: ['02a86bfb-11ce-477e-9901-8db17733c4c6'],
        },
        {
          brand: 'Samsung',
          model: 'Galaxy',
          reviews: ['59a82808-46f0-4e4c-8bab-b6e2ea7526de'],
        },
        {
          brand: 'Google',
          model: 'Pixel',
          reviews: [],
        },
      ],
      '528': [
        {
          brand: 'Apple',
          model: 'MacBook',
          reviews: ['35d508d9-9de7-4453-95dc-fbcf0a5e5d45'],
        },
      ],
      '5': [
        {
          brand: 'Apple',
          model: 'iPad',
          reviews: ['d88c5029-eb33-453b-ab29-9fc910243d43'],
        },
      ],
    },
  },
  {
    countryCode: 'IT',
    categories: {
      '2': [
        {
          brand: 'Apple',
          model: 'iPhone',
          reviews: ['e03128b9-8133-451f-b273-fae7a082f693'],
        },
        {
          brand: 'Samsung',
          model: 'Galaxy',
          reviews: ['9c38cb8e-c009-4355-b6ec-87567580fc78'],
        },
        {
          brand: 'Google',
          model: 'Pixel',
          reviews: [],
        },
      ],
      '528': [
        {
          brand: 'Apple',
          model: 'MacBook',
          reviews: ['678e992e-eccb-436a-af5b-399c0fe0b4af'],
        },
      ],
      '5': [
        {
          brand: 'Apple',
          model: 'iPad',
          reviews: ['5f5ab133-a27f-4b45-9923-a959028bf4b2'],
        },
      ],
    },
  },
])
